/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TasksTask from './TasksTask';

/**
 * The TasksBody model module.
 * @module model/TasksBody
 * @version v0.3
 */
export default class TasksBody {
  /**
   * Constructs a new <code>TasksBody</code>.
   * @alias module:model/TasksBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TasksBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TasksBody} obj Optional instance to populate.
   * @return {module:model/TasksBody} The populated <code>TasksBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TasksBody();
      if (data.hasOwnProperty('task'))
        obj.task = TasksTask.constructFromObject(data['task']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TasksTask} task
 */
TasksBody.prototype.task = undefined;

